import { AccountRole } from 'models/account.model';
import {
  AccountRightsDefs, Action, RightsType, Subject
} from 'models/roles.model';

export const manufacturerRightsDefinitions: AccountRightsDefs = {
  [Subject.Customer]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Read],
      [AccountRole.ADMIN]: [Action.Read],
      [AccountRole.SUPERADMIN]: [Action.Read]
    }
  },

  [Subject.ContactPerson]: {},

  [Subject.Objekt]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Conditions]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Read, Action.Update],
      [AccountRole.ADMIN]: [Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Read, Action.Update]
    }
  },

  [Subject.Templates]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Read],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Articles]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Branch]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update]
    }
  },

  [Subject.OfferTemplates]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.OfferTemplateSettings]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.OfferSettings]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.Account]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update]
    }
  },

  [Subject.Branches]: {},

  [Subject.HeaderNavSettings]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Read],
      [AccountRole.SUPERADMIN]: [Action.Read]
    }
  },

  [Subject.ImportCustomer]: {},
  [Subject.ExportCustomer]: {},

  [Subject.ImportArticles]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Create, Action.Read, Action.Update],
      [AccountRole.SUPERADMIN]: [Action.Create, Action.Read, Action.Update, Action.Delete]
    }
  },

  [Subject.ExportArticles]: {
    [RightsType.Organization]: {
      [AccountRole.USER]: [],
      [AccountRole.ADMIN]: [Action.Read],
      [AccountRole.SUPERADMIN]: [Action.Read]
    }
  },
};
